import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - APP BAR ||============================== //

/** Barra superior alinhada ao shell do drawer: flat, borda inferior, sem gradiente/sombra. */
export default function AppBar(theme: Theme) {
  const border = theme.palette.mode === 'light' ? '#E0E0E0' : theme.palette.divider;
  const shellBg = theme.palette.mode === 'light' ? '#F5F5F5' : theme.palette.grey[100];

  return {
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
        color: 'default'
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none !important',
          backgroundColor: `${shellBg} !important`,
          color: theme.palette.text.primary,
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
          boxShadow: 'none !important',
          borderRadius: 0,
          border: 'none',
          borderBottom: `1px solid ${border}`
        }
      }
    }
  };
}
